module.exports = __webpack_public_path__ + "img/salsa_4347.bf177c44.jpg";